import React, { useRef, useState } from 'react';
import useSessionStorage from '../../../hooks/useSessionStorage';
import CreateDynamicJob from '../createDynamicJob';
import Modal from "./modal";
const SummaryDyanamicJob = (props) => {
    const [showModal, setShowModal] = useState(false);
    const storage = useSessionStorage();
    const inputTypes = storage.getItem('inputTypes');
    const commonselctRef = useRef([]);
    // console.log(props);
    const edit = (event) => {
        event.preventDefault();
        setShowModal(!showModal);
    };
    const save = (event) => {
        event.preventDefault();
        props.sumbitJobDetails(false).then(success => {
            if (success) {
                setShowModal(!showModal);
            }
        });
    };
    return (
        <>
            {props?.dynamicForm ? props?.dynamicForm?.map(item => (
                    <div className="card h-100">
                        {
                            showModal && <Modal label={"Template Info"} showHide={edit} saveFunction={save}>
                                <CreateDynamicJob errors={props.errors} commonselctRef={commonselctRef} />
                            </Modal>
                        }
                    <div className="card-header">
                                    <b><h5 className='mb-0'>{item?.formNameToDisplay}</h5></b>
                                    {
                                        props.editMode && <a className="edit-icon" id="btnShowModel_Job_Type" href="#" onClick={edit}>
                                            <i className="fe fe-edit" title="Edit Template"></i>
                                        </a>
                                    }
                                </div>
                        <div className="card-body">
                            {item?.controlsInfo.map(val => (
                                <>
                                    {
                                        inputTypes?.ReactMultiSelectDropdown === val?.controlType ? (<div className="form-group">
                                            <div className="col-lg-12 col-md-12">
                                                <label className="form-label"> {val?.label}</label>
                                                <label htmlFor="Location Name">{
                                                    val?.selectedValueOptions?.map(seleected => (
                                                        <div>{seleected.name}</div>
                                                    ))
                                                }
                                                </label>
                                            </div>
                                        </div>) : ('')
                                    }
                                </>
                            ))}

                        </div>
                    </div>
            )) : ''}
        </>
    )
}

export default SummaryDyanamicJob;
